// extracted by mini-css-extract-plugin
module.exports = {"chartTagsList":"chartTagsList_chartTagsList__2nbhG","tag":"chartTagsList_tag__L7blH","agreements":"chartTagsList_agreements__1c-q9","tagDelete":"chartTagsList_tagDelete__3t3B_"};